import { RootState } from 'common/redux/core/root.reducer';

export const getTrendingDataFn = (state: RootState) => state.configurationData.trendingData;

export const getSelectedFiles = (state: RootState) => state.configurationData.selectedFiles;

export const getUploadingFiles = (state: RootState) => state.configurationData.uploadingFiles;
export const getUploadedStatus = (state: RootState) => state.configurationData.uploadStatus;
export const getWhatsNewLinkSaveStatus = (state: RootState) =>
    state.configurationData.saveWhatsNewLink;

export const getUploadModalVisibility = (state: RootState) =>
    state.configurationData.isUploadModalVisible;

export const getFieldErrors = (state: RootState) => state.configurationData.fieldErrors;

export const getKeyIndicatorsResponse = (state: RootState) => state.configurationData.keyIndicators;

export const getStaticIndicatorsResponse = (state: RootState) =>
    state.configurationData.staticIndicators;

export const getFrequentlyUsedResponse = (state: RootState) =>
    state.configurationData.frequentlyUsed;

export const getHierarchicalDataFn = (state: RootState) => state.configurationData.hierarchicalData;

export const getHierarchicalDataValue = (state: RootState) =>
    state.configurationData.hierarchicalData?.data?.data;

export const getWhatsNewResponse = (state: RootState) => state.configurationData.whatsNew;

export const getSelectedIndicatorsForAdd = (state: RootState) =>
    state.configurationData.selectedIndicatorsForAdd;

export const getGeographyOverviewResponse = (state: RootState) =>
    state.configurationData.geographyOverview;

export const getFileUploadLogDataResponse = (state: RootState) =>
    state.configurationData.fileUploadLogData;

export const getConfigurationDeleteResponse = (state: RootState) =>
    state.configurationData.deleteData;

export const getConfigurationReorderResponse = (state: RootState) =>
    state.configurationData.reorderData;

export const getConfigurationSaveResponse = (state: RootState) =>
    state.configurationData.saveIndicator;

export const getTrendingDataSaveResponse = (state: RootState) =>
    state.configurationData.saveTrendingData;

export const getWhatsNewIndicaotrSaveResponse = (state: RootState) =>
    state.configurationData.saveWhatsNewIndicator;

export const getIndicatorSourcesResponse = (state: RootState) =>
    state.configurationData.indicatorSources;

export const getIndicatorSourceAddResponse = (state: RootState) =>
    state.configurationData.addIndicatorSource;

export const getIndicatorSourceEditResponse = (state: RootState) =>
    state.configurationData.updateIndicatorSource;

export const getVideoLinkResponse = (state: RootState) =>
    state.configurationData.videoLink;
